const HeaderLinks = {
    mightyjaxx: "https://mightyjaxx.com",
    mightyallstars: "https://mightyjaxx.com/pages/mighty-allstars"
};

export default HeaderLinks;